module.exports = [{
      plugin: require('/Users/taf/gatsby-starter-ghost/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/taf/gatsby-starter-ghost/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
